import Axios from "axios";
import React, { useContext } from "react";
import { configContext } from "../config-provider";
// import { BarChart } from "../bar-chart";
// import { latestMonth } from "../../utils";
import { LineChart } from "../line-chart";
import { Spin } from "../loading";

interface InspectOverviewProps {}

interface State {
  barChart: unknown[];
  lineChart: unknown[];
  loading: boolean;
}

export const InspectOverview: React.FC<InspectOverviewProps> = (props) => {
  const { dataStartMonth } = useContext(configContext);
  const [state, setState] = React.useState<State>({
    barChart: [],
    lineChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/inspect/overview`, { params: { from: dataStartMonth } })
      .then((res) => {
        const { lineChart, barChart } = res.data;

        setState({
          ...state,
          lineChart: [{ data: lineChart[0], label: "Lantern Cleaning" }, { data: lineChart[1], label: "Column Inspection" }],
          barChart: [{ data: barChart[0], label: "Lantern" }, { data: barChart[1], label: "Column" }],
        });
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview full-height">
      <span className="title">schedule maintenance record overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}

        <div style={{ width: "100%", flex: 1 }}>
          <Spin spin={state.loading}>
            <LineChart data={state.lineChart} />
          </Spin>
        </div>
      </div>

      {/* Disabled. If re-enabled, the bar chart counts SUB_DATE across the
          month one month back - see `countLastMonth()` in the server's
          inspect.service.ts - so the heading names that month, not two back
          like the fault/complaint/programme pages. */}
      {/* <div>
        <span className="title">
          Latest Month <span className="month">&mdash; {latestMonth(1)}</span>
        </span>
        <div className="latest">
          <Spin spin={state.loading}>
            <BarChart data={state.barChart} />
          </Spin>
        </div>
      </div> */}
    </div>
  );
};
